import { useEffect, useState } from 'react';

// Promo -50% Suivi Pro+ annuel : source de vérité unique = le backend
// (get_solo_annual_pricing), qui se désactive tout seul après le 31 octobre 2026 —
// aucune logique de date ni de prix à dupliquer/maintenir côté frontend.
export const useSoloAnnualPromo = () => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/transformation/config`)
      .then((r) => r.json())
      .then((cfg) => {
        const s = cfg?.offers?.solo;
        if (!s) return;
        setPromo({
          active: !!s.annual_promo_active,
          price: s.annual_price,
          originalPrice: s.annual_original_price,
          discountPct: s.annual_discount_pct,
          endsAt: s.annual_promo_ends_at,
        });
      })
      .catch(() => {});
  }, []);

  return promo; // null tant que non chargé, { active: false, ... } si promo expirée
};
